import React from 'react';
import { CraneUseService } from '../../../services/CraneUses';
import { CommonHistoryDropdown } from './CommonHistoryDropdown';

/**
 * 揚重機予定履歴取得ドロップダウン
 * @param fieldTreeId {int} 協力会社ID
 * @param column {string} カラム名
 * @param set {function} 選択した値
 */
export class CraneUseLatestRegistrationDropdown extends React.Component {
  /**
   * 履歴取得
   */
  getHistories = async fieldId => {
    if (!this.props.fieldTreeId) {
      return null;
    }

    let params = {
      field_id: fieldId,
      field_tree_id: this.props.fieldTreeId,
      column: this.props.column,
    };

    return await CraneUseService.registrationHistoryList(fieldId, params).then(
      response => {
        if (response.result) {
          return response.data.entities.crane_uses;
        } else {
          return null;
        }
      }
    );
  };

  render() {
    return (
      <CommonHistoryDropdown
        {...this.props}
        getHistories={this.getHistories}
        resetKeys={[this.props.fieldTreeId]}
        maxLength={this.props.column === 'safety_instruction' ? 512 : 255}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/CraneUseLatestRegistration.jsx